import {reloadIfNotOnCooldown} from "@/utility/reloading"

const reloadKey = "chunkLoadErrorReloadAt"

export function isChunkLoadError(error: unknown): boolean {
	if (!(error instanceof Error))
		return false

	// Webpack 5 sets `name = "ChunkLoadError"` and a `chunkId` property;
	// the message check covers any bundler that doesn't set the name.
	return error.name === "ChunkLoadError" || error.message.startsWith("Loading chunk")
}

export function recoverFromChunkLoadError(error: unknown): boolean {
	if (!isChunkLoadError(error) || !window.navigator.onLine)
		return false

	return reloadIfNotOnCooldown(reloadKey)
}
